<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid px-0" style="height:100%;">
    <ul class="nav nav-tabs nav-tabs-highlight mb-0 mr-0">
      <li class="nav-item" style="border-left-width:0px !important">
        <a v-bind:href="'#add-user-Panel' + getId()" style="" class="nav-link active show" data-toggle="tab">
          {{$t('add')}}
        </a>
      </li>
      <li class="nav-item">
        <a v-bind:href="'#invite-user-Panel' + getId()" class="nav-link" data-toggle="tab">
          {{$t('share')}}
        </a>
      </li>
    </ul>
    <div class="container-fluid" v-bind:id="getId()" ref="container" style="">
      <div class="row" style="height: 100%">
        <div class="col p-2" style="padding-left:0px !important">
          <div class="tab-content border-top-0 rounded-top-0 mb-0" style="height: 100%">
            <div v-bind:id="'add-user-Panel' + getId()" class="tab-pane fade show active pl-1" style="height: 100%">
              <invite-user ref="usersInviteControl"></invite-user>
              <!--<procedure-workmode @add_pending_chat_message="addPendingChatMessage" v-bind:isshifttask="isshifttask" v-bind:assigned="assigned" ref="workmode" @done="save" @assign="assign" @advanced="advanced" @changed="changed" v-bind:scheduleid="scheduleid"></procedure-workmode>-->
            </div>
            <div v-bind:id="'invite-user-Panel' + getId()" class="tab-pane fade pl-1" style="height: 100%">
              <invite-user-share></invite-user-share>
              <!--<procedure-workmode @add_pending_chat_message="addPendingChatMessage" v-bind:isshifttask="isshifttask" v-bind:assigned="assigned" ref="workmode" @done="save" @assign="assign" @advanced="advanced" @changed="changed" v-bind:scheduleid="scheduleid"></procedure-workmode>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: "invite-user-tab",
    components: {

    },
    props: {

    },
    data() {
      return {


      }
    },
    computed: {

    },
    methods: {
      getId() {
        return "container_" + this._uid;
      },
      clearFields() {
        this.$refs.usersInviteControl.clearFields();
      },
      loadGroupsOnDemand(group) {
        this.$refs.usersInviteControl.loadGroupsOnDemand(group);
      },
    },
    mounted() {


    },
    created: function () {

    },
    watch: {

    },
  };

</script>

<style scoped>
  .padding-helptext-menu {
    padding-bottom: 80px;
  }

  .padding-helptext-nomenu {
    padding-bottom: 80px;
  }

  .padding-nohelptext-menu {
    padding-bottom: 0px;
  }

  .padding-nohelptext-nomenu {
    padding-bottom: 0px;
  }


  .padding-helptextmargin {
    padding-bottom: 80px;
  }

  .padding-nomargin {
    padding-bottom: 0px;
  }




  .nav-link.active::before {
  }

  .nav-link {
    padding-left: 15px;
    padding-right: 15px;
  }

    .nav-link.active {
      background-color: white !important;
    }

  .tab-content {
    /*background-color: white !important;*/
  }

  #procedureTabs {
    margin-right: 8px;
  }

  .editor-container {
    height: calc(-105px + 100vh);
    overflow-y: auto;
  }

  .procedure-quicksave {
    position: fixed;
    bottom: 12px;
    right: 17px;
    z-index: 1002;
    width: 30%;
    z-index: 5002;
  }

  .procedure-done-reject {
    position: fixed;
    bottom: 12px;
    right: 17px;
    z-index: 1002;
    width: 30%;
    z-index: 5001;
  }

  @media (max-width: 768px) {

    .padding-helptext-menu {
      padding-bottom: 145px;
    }

    .padding-helptext-nomenu {
      padding-bottom: 80px;
    }

    .padding-nohelptext-menu {
      padding-bottom: 65px;
    }

    .padding-nohelptext-nomenu {
      padding-bottom: 0px;
    }

    .procedure-quicksave {
      width: unset;
      right: 17px;
      left: 24px;
      bottom: 40px;
    }

    .procedure-done-reject {
      width: unset;
      right: 17px;
      left: 24px;
      bottom: 40px;
    }

    #procedureTabs {
      margin-right: 0px;
    }

    .editor-container {
      height: calc(-50px + 100%);
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/invite-user-tab.vue